<div class="process-card">
  <!-- Card header -->
  <div class="card-header text-center">
    <img src="/assets/icons/avyna/logo.svg" [alt]="'onboarding.shared.logoAlt' | translate" class="brand-logo mb-3" />
    <div class="header-text">
      <h1 class="title-text">{{ 'onboarding.auth.callback.title' | translate }}</h1>
      <p class="subtitle-text">{{ 'onboarding.auth.callback.subtitle' | translate }}</p>
    </div>
  </div>

  <div class="content-area">
    <!-- Step list -->
    <ul class="step-list">
      @for (step of steps(); track step.id) {
        <li
          class="step-row"
          [class.is-active]="step.state === 'loading'"
          [class.is-done]="step.state === 'completed'"
          [class.is-error]="step.state === 'error'"
          [class.is-pending]="step.state === 'pending'"
        >
          <span class="step-icon">
            @switch (step.state) {
              @case ('completed') {
                <mat-icon class="icon-done icon-md">check_circle</mat-icon>
              }
              @case ('loading') {
                <mat-spinner class="icon-spinner" [diameter]="20" [strokeWidth]="2"></mat-spinner>
              }
              @case ('error') {
                <mat-icon class="icon-error icon-md">error</mat-icon>
              }
              @default {
                <mat-icon class="icon-pending icon-md">radio_button_unchecked</mat-icon>
              }
            }
          </span>
          <span class="step-label">{{ step.label | translate }}</span>
        </li>
      }
    </ul>

    <!-- Progress bar -->
    <div class="progress-wrapper">
      <mat-progress-bar mode="determinate" [value]="progress()" class="custom-progress-bar"></mat-progress-bar>
      <div class="progress-label text-end mt-1">{{ progress() | number: '1.0-0' }}%</div>
    </div>

    <!-- Error block -->
    @if (hasError()) {
      <div class="error-view animate-fade-in">
        <div class="error-alert">
          <mat-icon class="error-icon icon-md">gpp_bad</mat-icon>
          <div class="error-body">
            <h2 class="error-title">{{ 'onboarding.auth.callback.errorTitle' | translate }}</h2>
            <p class="error-desc">{{ errorDetail() }}</p>
          </div>
        </div>

        <div class="actions-area">
          <button mat-flat-button class="action-btn primary-btn" (click)="retryAuth()">
            {{ 'onboarding.auth.callback.tryAgain' | translate }}
          </button>
          <button mat-stroked-button class="action-btn" (click)="returnToLogin()">
            {{ 'onboarding.auth.callback.backToLogin' | translate }}
          </button>
        </div>
      </div>
    }
  </div>

  <!-- Card footer -->
  <div class="card-footer">
    <mat-icon class="secure-icon">lock</mat-icon>
    <span>{{ 'onboarding.auth.callback.footer' | translate }}</span>
  </div>
</div>
